import { CreditMemo } from "@dana/Services/CreditService";
import { GetCreditMemosParameter } from "@dana/Store/Data/ViewCredit/Handlers/ViewCreditHandler";
import ViewCreditState from "@dana/Store/Data/ViewCredit/ViewCreditState";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { PaginationModel } from "@insite/client-framework/Types/ApiModels";
import { Draft } from "immer";

const initialState: ViewCreditState = {
    isLoading: false,
    allCredits: [],
    creditMemos: [],
    pagination: {} as any,
    creditsCount: 0,
    appliedCreditAmount: 0,
    openCreditAmount: 0,
    filter:{ sortBy: "CreditMemoDate", sort: "DESC", page: 1, pageSize: 12 }
};

const ViewCreditStateStateImmerReducer = createTypedReducerWithImmer(initialState, {
    "CreditViewState/Init": (draft: Draft<ViewCreditState>, action: { isLoading: boolean }) => {
        draft = { ...initialState, isLoading: action.isLoading };
        return draft;
    },
    "CreditViewState/IsLoading": (draft: Draft<ViewCreditState>, action: { isLoading: boolean }) => {
        draft = { ...draft, isLoading: action.isLoading };
        return draft;
    },
    "CreditViewState/UpdateViewCreditFilter": (draft: Draft<ViewCreditState>, action: { filter: GetCreditMemosParameter }) => {
        draft = { ...draft, filter: action.filter };
        return draft;
    },
    "CreditViewState/LoadCredits": (draft: Draft<ViewCreditState>, action: { allCredits: CreditMemo[],creditMemos: CreditMemo[], pagination: PaginationModel, creditsCount: number, appliedCreditAmount: number, openCreditAmount: number }) => {
    
        draft = {
            ...draft,
            allCredits: action.allCredits,
            creditMemos: action.creditMemos,
            pagination: action.pagination,
            creditsCount: action.creditsCount,
            appliedCreditAmount: action.appliedCreditAmount,
            openCreditAmount: action.openCreditAmount,
            
        };
        return draft;
    },

});

(reducers as any).viewCreditState = ViewCreditStateStateImmerReducer;

type CreditStateReducers = {
    viewCreditState: typeof ViewCreditStateStateImmerReducer;
};

export type CreditStateActions = Parameters<CreditStateReducers[keyof CreditStateReducers]>[1] | AnyAction;

